var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.02155H6V20.0215H18V6.02155ZM5 5.02155V21.0215H19V5.02155H5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2.47845H18.5V5.53521H17.5V3.47845H6.5V5.53521H5.5V2.47845Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91425 9H8.91425V10H9.91425V9ZM7.91425 8V11H10.9142V8H7.91425Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9142 9.01732H13.9142V10.0173H14.9142V9.01732ZM12.9142 8.01732V11.0173H15.9142V8.01732H12.9142Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91425 13.0363H8.91425V14.0363H9.91425V13.0363ZM7.91425 12.0363V15.0363H10.9142V12.0363H7.91425Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9142 17.0215H8.91425V20.0215H14.9142V17.0215ZM7.91425 16.0215V21.0215H15.9142V16.0215H7.91425Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9142 13.0173H13.9142V14.0173H14.9142V13.0173ZM12.9142 12.0173V15.0173H15.9142V12.0173H12.9142Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03828 20.5215C3.03828 20.2454 3.26213 20.0215 3.53828 20.0215H20.4617C20.7379 20.0215 20.9617 20.2454 20.9617 20.5215C20.9617 20.7977 20.7379 21.0215 20.4617 21.0215H3.53828C3.26213 21.0215 3.03828 20.7977 3.03828 20.5215Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.0215C12.2761 16.0215 12.5 16.2454 12.5 16.5215V20.5215C12.5 20.7977 12.2761 21.0215 12 21.0215C11.7239 21.0215 11.5 20.7977 11.5 20.5215V16.5215C11.5 16.2454 11.7239 16.0215 12 16.0215Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.8671b1c003c79a94f0e5d57573cce8c9.svg";
export { ForwardRef as ReactComponent };